import React, { Dispatch, SetStateAction } from 'react';
import {
  AddressValidationRequest,
} from './utilities/growthConnector';
import { useAddressVerification } from './hooks/useAddressVerificationHook';
import Modal from './Modal';
import './assets/scss/addressVerification.scss';
import { NO_SUGGESTION, SUGGESTION_AVAILABLE, VERIFIED } from './constants';
import getGrowthBaseUrlFromEnv from './utilities/moduleUtilities';
import { VerifiedAddress } from './addressVerificationTypes';

function AddressVerification(props: {
  submitAddressCallback: (addressToSubmit: VerifiedAddress) => void;
  addressToValidate: AddressValidationRequest;
  setShowAddressVerification: Dispatch<SetStateAction<boolean>>;
  env: string | undefined;
}) {
  const {
    submitAddressCallback, addressToValidate, setShowAddressVerification, env,
  } = props;
  const addressVerificationResponse = useAddressVerification(
    getGrowthBaseUrlFromEnv(env),
    addressToValidate,
  );

  const submitAddress = (addressTypeToSubmit: string) => {
    const addressToSubmit = addressTypeToSubmit === VERIFIED
      ? addressVerificationResponse.verified : addressVerificationResponse.submitted;
    submitAddressCallback(addressToSubmit);
  };

  if (!addressVerificationResponse) {
    return null;
  }

  if (
    addressVerificationResponse.modalType === NO_SUGGESTION
    || addressVerificationResponse.modalType === SUGGESTION_AVAILABLE
  ) {
    return (
      <Modal
        handleSubmitClick={submitAddress}
        addressVerificationResponse={addressVerificationResponse}
        setShowAddressVerification={setShowAddressVerification}
      />
    );
  }

  // both addresses are the same and deliverable
  // don't show the modal at all, just submit the address
  if (addressVerificationResponse.modalType === VERIFIED) {
    addressVerificationResponse.modalType = undefined;
    submitAddress(VERIFIED);
  }
  return null;
}

export default AddressVerification;
